import { HeaderMode } from '../../table-header/enums/HeaderMode';
import { GridState, GridStateActions, GridEvent, GridNotification, NotificationData } from './grid-state.interface';

/**
 * Edit State - When inline editing is active
 */
export class EditState implements GridState {
  getMode(): HeaderMode {
    return HeaderMode.Edit;
  }

  onEnter(actions: GridStateActions): void {
    actions.disableCheckboxColumn();
    actions.disableEditColumn();
    actions.enableInlineEditing();
    actions.enableSingleClickEdit();
    actions.applyBoldToEditedRows();
  }

  onExit(actions: GridStateActions, event: GridEvent): void {
    if (event === 'SAVE') {
      actions.cleanEditedRows();
    } else if (event === 'CANCEL') {
      actions.cleanAllState();
    }
  }

  canTransitionTo(event: GridEvent): HeaderMode | null {
    switch (event) {
      case 'SAVE':
        return HeaderMode.Idle;
      case 'CANCEL':
        return HeaderMode.Idle;
      default:
        return null;
    }
  }

  handleNotification(notification: GridNotification, data: NotificationData, actions: GridStateActions): GridEvent | null {
  switch (notification) {
    case 'CELL_EDITED':
      actions.enableSingleClickEdit(); 
      actions.applyBoldToEditedRows();
      return null;

    case 'ROW_SELECTION_CHANGED':
      if (data.selectedCount && data.selectedCount > 0) {
        return 'SELECT';
      }
      return null;

    default:
      return null;
  }
}

  getDataToSave(context: { duplicatedRows: any[]; editedRows: Map<number, any> }): any[] {
    return [...context.editedRows.values()];
  }
}
